import React from 'react';
import Dropdown from 'components/shared/Dropdown/Dropdown';
import classNames from 'classnames';

const MaintenancePanelDropdownTilt = (props) => {
  return (
    <div
      id={props.id}
      className={classNames(
        {
          maintenanceBarTile: true,
          maintenanceBarTile_Disabled: props.disabled
        },
        props.className
      )}
      data-tip={props.hoveredOverText}
    >
      <Dropdown
        role="menuitem"
        hideArrow={props.hideArrow}
        disabled={props.disabled}
        sendId={(selection) => props.handleMBarSelection(selection)}
        title={props.title}
        data={props.dropdownData}
        ids={props.dropdownIds}
      />
    </div>
  );
};

export default MaintenancePanelDropdownTilt;
